const generalSearch = () => {
    if(document.querySelector('.ume-starter-general-search')){
        const doSearch = (ev) =>{
            if (!(ev.target.parentNode.closest('.ume-starter-general-search') || ev.target.classList.contains('ume-starter-general-search'))) {
                return;
            }
            const searchQuery = document.querySelector('.ume-starter-search-input').value;

            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#x27;',
                "/": '&#x2F;',
            };
            const reg = /[&<>"'/]/ig;

            const cleanQuery = searchQuery.replace(reg, (match)=>(map[match]));
            const target = window.location.origin+'/?s='+cleanQuery;
            window.location.href = target;
        }
        document.addEventListener('click', ev => {doSearch(ev)});
        document.addEventListener('keypress', ev =>{
            if (ev.key === 'Enter') {
                if(ev.target !== null && ev.target.classList.contains('ume-starter-search-input')) {
                    const holder = ev.target.parentNode;
                    const button = holder.querySelector('.ume-starter-general-search');
                    button.click()
                }

                if(ev.target !== null && ev.target.classList.contains('ume-projects-search-input')) {
                    const holder = ev.target.parentNode;
                    const button = holder.querySelector('.ume-projects-search');
                    button.click();
                }else return;
            }



        })

    }
}
export default generalSearch;